// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { CognitoError } from "./client";
/**
 * Maps a Cognito IDP exception name to an i18n key under `auth.errors.*`
 * so the UI never shows a raw AWS exception string to the user (never
 * invent friendlier text than what actually happened, but never leak
 * implementation detail either — translate the known, stable set).
 */
const KNOWN_CODES = new Set([
    "UsernameExistsException",
    "InvalidPasswordException",
    "InvalidParameterException",
    "CodeMismatchException",
    "ExpiredCodeException",
    "UserNotConfirmedException",
    "UserNotFoundException",
    "NotAuthorizedException",
    "LimitExceededException",
    "TooManyRequestsException",
    "TooManyFailedAttemptsException",
    "ChallengeRequired",
    "MissingRefreshToken",
    // Social sign-in (OAuth code + PKCE via the Cognito domain)
    "OAuthCancelled",
    "OAuthStateMismatch",
    "OAuthTokenError",
]);
export function cognitoErrorMessageKey(error) {
    if (error instanceof CognitoError && KNOWN_CODES.has(error.code)) {
        return `auth.errors.${error.code}`;
    }
    return "auth.errors.generic";
}
